import { ElMessage } from 'element-plus';
import { NavigationGuard, Router } from 'vue-router';
import type * as piniaStore from '@/store';
import { ApiError } from '@/api';
import { ROUTE } from '@/router/routes-enum';
import { APP_NAME } from '@/constants/base';

const whiteList = ['/404', '/500']; // no redirect whitelist
const errorPages = ['/404', '/500'];

// Сорри, решил не париться
let firstLoad = true;

type GlobalRouterGuardType = (store: typeof piniaStore, router: Router) => NavigationGuard;
export const globalRouterGuard: GlobalRouterGuardType = (store, router) => async (to) => {
  // set page title
  document.title = to.meta.title ? `${APP_NAME} - ${to.meta.title}` : `${APP_NAME} admin`;

  const { useRouterStore, useUserStore } = store;

  try {
    // ну тут жопа пацаны
    // если роут в вайт листе, просто пускаем туда без заморочек
    if (whiteList.includes(to.path)) {
      // однако если это страница-ошибка и юзер зашел туда сам, редиректим на главную
      if (errorPages.includes(to.path) && firstLoad) {
        firstLoad = false;
        return { path: '/' };
      }
      return;
    }

    const { userInfoFetched } = useUserStore();

    if (userInfoFetched) {
      return;
    }

    try {
      const { rights } = await useUserStore().fetchUserInfo();

      // генерируем роуты, на которые он может ходить
      useRouterStore().generateRoutes(rights, router);
      return { ...to, replace: true };
    } catch (error) {
      // если не удалось получить данные юзера,
      // значит что-то не так с бэком
      return { name: ROUTE.ERR_500 };
    }

    // ну ладно иди дальше
  } catch (e) {
    // при получении 401 в любом случае кидаем его на страницу логина
    if (e instanceof ApiError && e.status === 401) {
      useUserStore().resetUser();

      if (useUserStore().userInfoFetched) {
        ElMessage.error('Need to authorize');
      }

      return {
        name: '/',
        params: {
          redirect: to.path,
        },
      };
    }
    throw e;
  }
};
